export function filterOffers(offers: OrangeAdsAPIResponse, filter_by_category?: string, filter_by_day?: string, filter_by_store?: string, filter_by_search?: string, filter_by_wishlist?: number[]) {

  type Filter = (x: OrangeAds) => boolean;

  const category_filter: Filter = filter_by_category ? (x) => {
    const category = offers.categories?.find((category) => String(category.id) == filter_by_category)?.name || '';
    return x.category.toLowerCase().includes(category.toLowerCase())
  } : () => true;

  const day_filter: Filter = filter_by_day ? (x) => {
    if (filter_by_day.toLowerCase() == 'all')
      return x.weekday_group.toLowerCase() == 'to-su'
    return filter_by_day.toLowerCase().includes(x.weekday_group.toLowerCase())
  } : () => true

  const store_filter: Filter = filter_by_store ? (x) => {
    return x.shop_name.toLowerCase() == filter_by_store.toLowerCase();
  } : () => true

  const search_filter: Filter = filter_by_search ? (x) => {
    const _name = x.name.toLowerCase();
    const _description = x.description.toLowerCase();
    const _shop = x.shop_name.toLowerCase();
    const _seach = filter_by_search.toLowerCase()
    return _name.includes(_seach) || _description.includes(_seach) || _shop.includes(_seach)
  } : () => true

  const wishlist_filter: Filter = filter_by_wishlist ? (x) => {
    return Boolean(filter_by_wishlist?.includes(x.id))
  } : () => true

  const items = offers.ad_list.reduce((acc: OrangeAds[], x) => {
    if (category_filter(x) && store_filter(x) && day_filter(x) && search_filter(x) && wishlist_filter(x)) {
      acc.push(x);
    }
    return acc;
  }, []);
  return items
}